import store from '@/store';

export default (to, from, next) => {
    if (!store.getters.token && to.path !== '/login') {
        return next({ path: '/login', query: { intent: to.path } });
    }

    return next();
};
